import {Injectable} from '@angular/core';
import {RestService} from 'shared/_services/rest.service';
import {Observable} from 'rxjs';
import {RestOptions} from 'shared/_interface/rest-options.interface';
import {RestMethods} from 'shared/enums';
import {LocalStorageService} from 'shared/_services/local-storage.service';
import {map} from 'rxjs/operators';
import {HttpResponse} from '@angular/common/http';
import {saveAs} from 'file-saver';

@Injectable({
	providedIn: 'root'
})
export class DataService {
	constructor(
		private rest: RestService,
		private localStorageService: LocalStorageService
		) {}
	apiUrl = (s: string) => this.rest.getUrl(s, true);
	get = <T>(url: string, params?: any, options?: RestOptions): Observable<T> =>
		this.rest.request(RestMethods.GET, url, {params}, options) as Observable<T>
	post = <T>(url: string, body: any, options?: RestOptions): Observable<T> =>
		this.rest.request<T>(RestMethods.POST, url, {body}, options) as Observable<T>
	put = <T>(url: string, body: any, options?: RestOptions): Observable<T> =>
		this.rest.request<T>(RestMethods.PUT, url, {body}, options) as Observable<T>
	delete = <T>(url: string, params?: any, options?: RestOptions): Observable<T> =>
		this.rest.request(RestMethods.DELETE, url, {params}, options) as Observable<T>

	getLocal = (path: string): Observable<any> => this.localStorageService.get(path);
	getLocalPrevious = () => this.localStorageService.getOldValues();
	setInstant = (path: string, value: any) => this.localStorageService.setInstant(path, value);
	removeItem = (path: string) => this.localStorageService.remove(path);
	getLocalSnapshot = (path: string) => this.localStorageService.getSnapshot(path);
	downloadFile = (url: string, fileName?: string, params?: any, options?: RestOptions): Observable<Blob> =>
		this.rest.request(RestMethods.GET, url, {params}, {...options, fullResponse: true, asBlob: true}).pipe(
			map(res => this.download(res as any, fileName))
		) as Observable<any>
	downloadFilePost = (url: string, fileName?: string, body?: any, options?: RestOptions): Observable<Blob> =>
		this.rest.request(RestMethods.POST, url, {body}, {...options, fullResponse: true, asBlob: true}).pipe(
			map(res => this.download(res as any, fileName))
		) as Observable<any>

	download(source: HttpResponse<any>, fileName?: string) {
		const headers = source.headers;
		const contentDisposition = headers.get('Content-Disposition');
		let filename;
		let response;
		if (contentDisposition && !fileName) {
			try {
				const  arr = contentDisposition.split(';');
				const name = arr.find(i => i.match('filename='));
				filename = name.trim().replace('filename=', '').replace(/"/g, '');
			} catch (e) {

			}
		} else filename = fileName;

		response = {
			blob: new Blob([source.body], { type: 'blob' }),
			filename
		};
		saveAs(response.blob, response.filename);
		return source;

	}
}
